export const GET_ALL_RESTRUCTURING_AGREEMENT = "GET_ALL_RESTRUCTURING_AGREEMENT"
export const CREATE_RESTRUCTURING_AGREEMENT = "CREATE_RESTRUCTURING_AGREEMENT"
export const UPDATE_RESTRUCTURING_AGREEMENT = "UPDATE_RESTRUCTURING_AGREEMENT"
export const DELETE_RESTRUCTURING_AGREEMENT = "DELETE_RESTRUCTURING_AGREEMENT"
